import React from 'react';
import { Lock, Zap, ShieldCheck, Smartphone, Download, Flame, Star, Crown } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
export function OfferSection() {
  const items = [{
    emoji: '📘',
    title: 'MegaPack Mecánica Básica para No Mecánicos',
    subtitle: '6 Tomos Completos',
    price: '$24.990',
    highlight: true
  }, {
    emoji: '🚗',
    title: 'Bono 1',
    subtitle: 'Guía Visual de Luces del Tablero',
    price: '$4.990'
  }, {
    emoji: '📋',
    title: 'Bono 2',
    subtitle: 'Checklist Previaje Imprimible',
    price: '$3.990'
  }, {
    emoji: '📄',
    title: 'Bono 3',
    subtitle: 'Plantillas para Pedir Presupuestos',
    price: '$4.990'
  }, {
    emoji: '💰',
    title: 'Bono 4',
    subtitle: 'Guía de Costos de Reparaciones Comunes',
    price: '$4.990'
  }, {
    emoji: '🧰',
    title: 'Bono 5',
    subtitle: 'Kit de Emergencias del Automóvil',
    price: '$4.990'
  }, {
    emoji: '🚘',
    title: 'Bono 6',
    subtitle: 'Manual Express para Comprar Autos Usados',
    price: '$4.990'
  }];
  return <section id="oferta" className="py-8 md:py-12 bg-[#171717] border-b border-[#262626]" data-id="element-163">
      <div className="max-w-xl mx-auto px-4 md:px-6" data-id="element-164">
        <SectionReveal className="text-center mb-4" data-id="element-165">
          <div className="inline-flex items-center gap-2 text-[#F59E0B] font-heading font-bold text-xs md:text-sm tracking-widest" data-id="element-166">
            <span className="text-lg" data-id="element-167">💰</span>
            OFERTA ESPECIAL DE LANZAMIENTO
          </div>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-168">
          <div className="bg-[#0a0a0a] border-2 border-[#F59E0B] rounded-sm shadow-[0_0_60px_rgba(245,158,11,0.2)] relative" data-id="element-169">
            {/* "Most chosen" ribbon */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#F59E0B] to-[#D97706] text-[#0a0a0a] font-heading font-bold text-[10px] md:text-xs tracking-widest px-4 py-1 rounded-sm whitespace-nowrap flex items-center gap-1.5 shadow-lg" data-id="element-170">
              <Star className="w-3 h-3 fill-current" data-id="element-171" />
              LA OPCIÓN MÁS ELEGIDA
              <Star className="w-3 h-3 fill-current" data-id="element-172" />
            </div>

            <div className="p-4 md:p-5 pt-7 md:pt-8" data-id="element-173">
              <h2 className="font-heading text-center text-base md:text-lg font-bold text-white mb-3 tracking-wide" data-id="element-174">
                Todo lo que recibís hoy:
              </h2>

              {/* Itemized list */}
              <div className="space-y-1.5 mb-4" data-id="element-175">
                {items.map((item, idx) => <div key={idx} className={`flex items-center gap-2 p-2 rounded-sm border ${item.highlight ? 'bg-[#F59E0B]/5 border-[#F59E0B]/40' : 'bg-[#171717] border-[#262626]'}`} data-id="element-176">
                    <div className="text-base md:text-lg flex-shrink-0" data-id="element-177">
                      {item.emoji}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-178">
                      <div className={`font-bold leading-tight ${item.highlight ? 'text-white text-xs md:text-sm' : 'text-white text-[11px] md:text-xs'}`} data-id="element-179">
                        {item.title}
                      </div>
                      <div className="text-[10px] md:text-[11px] text-[#9CA3AF] mt-0.5 leading-tight" data-id="element-180">
                        {item.subtitle}
                      </div>
                    </div>
                    <div className="font-heading font-bold flex-shrink-0 text-[#9CA3AF] text-xs md:text-sm line-through decoration-[#DC2626] decoration-2" data-id="element-181">
                      {item.price}
                    </div>
                  </div>)}
              </div>

              {/* Total value + discount badge inline */}
              <div className="flex justify-between items-center py-2 border-t border-[#262626]" data-id="element-182">
                <span className="font-heading text-[#9CA3AF] text-[11px] md:text-xs tracking-widest" data-id="element-183">
                  VALOR TOTAL
                </span>
                <div className="flex items-center gap-2" data-id="element-184">
                  <span className="font-heading text-sm md:text-base font-bold text-[#9CA3AF] line-through decoration-[#DC2626] decoration-2" data-id="element-185">
                    $53.930
                  </span>
                  <div className="inline-flex items-center gap-1 bg-[#DC2626] text-white font-heading font-bold text-[11px] md:text-xs px-2 py-0.5 rounded-sm tracking-wider shadow-lg shadow-[#DC2626]/30" data-id="element-186">
                    <Flame className="w-3 h-3 fill-current" data-id="element-187" />
                    63% OFF
                  </div>
                </div>
              </div>

              {/* Final price */}
              <div className="text-center bg-gradient-to-b from-[#F59E0B]/10 to-transparent border-y border-[#F59E0B]/30 py-4 mb-3 mt-2 relative" data-id="element-188">
                <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#F59E0B] text-[#0a0a0a] font-heading font-bold text-[10px] tracking-widest px-2.5 py-0.5 rounded-sm flex items-center gap-1" data-id="element-189">
                  <Crown className="w-2.5 h-2.5" data-id="element-190" />
                  PRECIO HOY
                </div>

                <div className="flex items-baseline justify-center gap-2 mb-1" data-id="element-191">
                  <span className="font-heading text-3xl md:text-5xl font-bold text-white leading-none" data-id="element-192">
                    $19.990
                  </span>
                  <span className="font-heading text-base md:text-lg text-[#F59E0B] font-bold" data-id="element-193">
                    ARS
                  </span>
                </div>
                <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-0.5 text-[10px] md:text-[11px] text-[#9CA3AF] font-medium" data-id="element-194">
                  <span data-id="element-195">Pago único</span>
                  <span className="text-[#262626]" data-id="element-196">•</span>
                  <span data-id="element-197">Acceso inmediato</span>
                  <span className="text-[#262626]" data-id="element-198">•</span>
                  <span data-id="element-199">Descarga digital</span>
                </div>
              </div>

              {/* Urgency line */}
              <div className="text-center mb-3" data-id="element-200">
                <p className="inline-flex items-center gap-1.5 text-[11px] md:text-xs text-[#F59E0B] font-medium" data-id="element-201">
                  <Flame className="w-3 h-3" data-id="element-202" />
                  Precio de lanzamiento — aumenta próximamente
                </p>
              </div>

              {/* CTA Button */}
              <a href="https://ebooksolutions.online/cart/46502134874166:1" target="_top" rel="noopener" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'MegaPack Mecánica Básica',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block w-full text-center bg-[#F59E0B] hover:bg-[#D97706] text-[#0a0a0a] font-heading font-bold text-base md:text-lg px-5 py-3.5 rounded-sm tracking-wider transition-all hover:scale-[1.01] active:scale-[0.99] shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_40px_rgba(245,158,11,0.6)] mb-3" data-id="element-203">
                🚀 ¡SÍ! QUIERO EL MEGAPACK
              </a>

              {/* Trust badges */}
              <div className="grid grid-cols-5 gap-1.5 pt-3 border-t border-[#262626]" data-id="element-204">
                {[{
                icon: Lock,
                label: 'Pago único'
              }, {
                icon: Zap,
                label: 'Inmediato'
              }, {
                icon: ShieldCheck,
                label: 'Garantía 7d'
              }, {
                icon: Smartphone,
                label: 'Multi-disp.'
              }, {
                icon: Download,
                label: 'Descarga'
              }].map((b, i) => {
                const Icon = b.icon;
                return <div key={i} className="flex flex-col items-center text-center gap-0.5" data-id="element-205">
                      <Icon className="w-3.5 h-3.5 text-[#F59E0B]" data-id="element-206" />
                      <span className="text-[8px] md:text-[9px] text-[#9CA3AF] font-medium leading-tight" data-id="element-207">
                        {b.label}
                      </span>
                    </div>;
              })}
              </div>
            </div>
          </div>
        </SectionReveal>
      </div>
    </section>;
}